import Input from './src/input';

export default Input;
